<template>
  <div class="audio-upload-wrapper">
    <template v-if="label">
      <label class="audio-upload-label mb-1">{{ label }}</label>
    </template>
    <div v-if="audioUrl" class="audio-preview">
      <audio :src="audioUrl" controls></audio>
      <button
        type="button"
        class="remove-btn"
        @click="removeAudio"
        :disabled="disabled"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div v-else class="upload-btn-wrapper">
      <input
        ref="audioInput"
        type="file"
        accept="audio/*"
        @change="onFileChange"
        style="display: none"
        :disabled="disabled"
      />
      <button
        type="button"
        class="upload-btn"
        @click="triggerInput"
        :disabled="disabled"
      >
        <i class="fas fa-upload"></i> {{ $t("BUTTONS.upload_audio") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AudioUpload",
  props: {
    value: [String, File], 
    preSelected: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      audioUrl: this.preSelected || null,
      file: null,
    };
  },
  watch: {
    preSelected(newVal) {
      this.audioUrl = newVal;
    },
    value(newVal) {
      if (newVal instanceof File) {
        this.audioUrl = URL.createObjectURL(newVal);
      } else {
        this.audioUrl = newVal;
      }
    },
  },
  mounted() {
    if (this.value instanceof File) {
      this.audioUrl = URL.createObjectURL(this.value);
    } else if (this.value) {
      this.audioUrl = this.value;
    } else if (this.preSelected) {
      this.audioUrl = this.preSelected;
    }
  },
  methods: {
    triggerInput() {
      if (!this.disabled) {
        this.$refs.audioInput.click();
      }
    },
    onFileChange(e) {
      if (this.disabled) return;
      const file = e.target.files[0];
      if (file && file.type.startsWith("audio/")) {
        this.file = file;
        const url = URL.createObjectURL(file);
        this.audioUrl = url;
        this.$emit("input", file);
        this.$emit("file-selected", file);
      } else {
        this.file = null;
        this.audioUrl = null;
        this.$emit("input", null);
      }
    },
    removeAudio() {
      if (this.disabled) return;
      this.file = null;
      this.audioUrl = null;
      this.$emit("input", null);
      this.$emit("file-removed");
      if (this.$refs.audioInput) this.$refs.audioInput.value = null;
    },
  },
};
</script>

<style scoped>
.audio-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.audio-upload-label {
  font-weight: 600;
  color: #333;
  font-size: 15px;
  margin-bottom: 4px;
}
.audio-preview {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f8f8f8;
  border-radius: 8px;
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
}
.remove-btn {
  background: #ff4d4f;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  transition: background 0.2s;
}
.remove-btn:hover {
  background: #d9363e;
}
.upload-btn-wrapper {
  display: flex;
  align-items: center;
}
.upload-btn {
  background: #0b7477;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.2s;
}
.upload-btn:hover {
  background: #095e60;
}
</style>
